/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_721Inputs */

const cs_ares_legal_form_721 = /** @type {(inputs: Ares_Legal_Form_721Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obec`)
};

const en_ares_legal_form_721 = /** @type {(inputs: Ares_Legal_Form_721Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Municipality`)
};

/**
* | output |
* | --- |
* | "Municipality" |
*
* @param {Ares_Legal_Form_721Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_721 = /** @type {((inputs?: Ares_Legal_Form_721Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_721Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_721(inputs)
	return cs_ares_legal_form_721(inputs)
});